import { createElementBlock as K, openBlock as B, renderSlot as A, createElementVNode as fe, defineComponent as Z, onMounted as ye, createBlock as be, resolveDynamicComponent as ke, withCtx as ve, h as W, Suspense as he, ref as Pe } from "vue";
function Se(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var G = { exports: {} }, Ee = G.exports, le;
function we() {
  return le || (le = 1, (function(e, i) {
    (function(d, p) {
      e.exports = p();
    })(Ee, (function() {
      var d = 1e3, p = 6e4, E = 36e5, h = "millisecond", m = "second", y = "minute", k = "hour", b = "day", x = "week", P = "month", ae = "quarter", L = "year", R = "date", ne = "Invalid Date", se = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, me = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, pe = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(l) {
        var n = ["th", "st", "nd", "rd"], r = l % 100;
        return "[" + l + (n[(r - 20) % 10] || n[r] || n[0]) + "]";
      } }, J = function(l, n, r) {
        var t = String(l);
        return !t || t.length >= n ? l : "" + Array(n + 1 - t.length).join(r) + l;
      }, ge = { s: J, z: function(l) {
        var n = -l.utcOffset(), r = Math.abs(n), t = Math.floor(r / 60), a = r % 60;
        return (n <= 0 ? "+" : "-") + J(t, 2, "0") + ":" + J(a, 2, "0");
      }, m: function l(n, r) {
        if (n.date() < r.date()) return -l(r, n);
        var t = 12 * (r.year() - n.year()) + (r.month() - n.month()), a = n.clone().add(t, P), u = r - a < 0, c = n.clone().add(t + (u ? -1 : 1), P);
        return +(-(t + (r - a) / (u ? a - c : c - a)) || 0);
      }, a: function(l) {
        return l < 0 ? Math.ceil(l) || 0 : Math.floor(l);
      }, p: function(l) {
        return { M: P, y: L, w: x, d: b, D: R, h: k, m: y, s: m, ms: h, Q: ae }[l] || String(l || "").toLowerCase().replace(/s$/, "");
      }, u: function(l) {
        return l === void 0;
      } }, O = "en", N = {};
      N[O] = pe;
      var te = "$isDayjsObject", q = function(l) {
        return l instanceof Y || !(!l || !l[te]);
      }, j = function l(n, r, t) {
        var a;
        if (!n) return O;
        if (typeof n == "string") {
          var u = n.toLowerCase();
          N[u] && (a = u), r && (N[u] = r, a = u);
          var c = n.split("-");
          if (!a && c.length > 1) return l(c[0]);
        } else {
          var _ = n.name;
          N[_] = n, a = _;
        }
        return !t && a && (O = a), a || !t && O;
      }, g = function(l, n) {
        if (q(l)) return l.clone();
        var r = typeof n == "object" ? n : {};
        return r.date = l, r.args = arguments, new Y(r);
      }, o = ge;
      o.l = j, o.i = q, o.w = function(l, n) {
        return g(l, { locale: n.$L, utc: n.$u, x: n.$x, $offset: n.$offset });
      };
      var Y = (function() {
        function l(r) {
          this.$L = j(r.locale, null, !0), this.parse(r), this.$x = this.$x || r.x || {}, this[te] = !0;
        }
        var n = l.prototype;
        return n.parse = function(r) {
          this.$d = (function(t) {
            var a = t.date, u = t.utc;
            if (a === null) return /* @__PURE__ */ new Date(NaN);
            if (o.u(a)) return /* @__PURE__ */ new Date();
            if (a instanceof Date) return new Date(a);
            if (typeof a == "string" && !/Z$/i.test(a)) {
              var c = a.match(se);
              if (c) {
                var _ = c[2] - 1 || 0, s = (c[7] || "0").substring(0, 3);
                return u ? new Date(Date.UTC(c[1], _, c[3] || 1, c[4] || 0, c[5] || 0, c[6] || 0, s)) : new Date(c[1], _, c[3] || 1, c[4] || 0, c[5] || 0, c[6] || 0, s);
              }
            }
            return new Date(a);
          })(r), this.init();
        }, n.init = function() {
          var r = this.$d;
          this.$y = r.getFullYear(), this.$M = r.getMonth(), this.$D = r.getDate(), this.$W = r.getDay(), this.$H = r.getHours(), this.$m = r.getMinutes(), this.$s = r.getSeconds(), this.$ms = r.getMilliseconds();
        }, n.$utils = function() {
          return o;
        }, n.isValid = function() {
          return this.$d.toString() !== ne;
        }, n.isSame = function(r, t) {
          var a = g(r);
          return this.startOf(t) <= a && a <= this.endOf(t);
        }, n.isAfter = function(r, t) {
          return g(r) < this.startOf(t);
        }, n.isBefore = function(r, t) {
          return this.endOf(t) < g(r);
        }, n.$g = function(r, t, a) {
          return o.u(r) ? this[t] : this.set(a, r);
        }, n.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, n.valueOf = function() {
          return this.$d.getTime();
        }, n.startOf = function(r, t) {
          var a = this, u = !!o.u(t) || t, c = o.p(r), _ = function($, S) {
            var M = o.w(a.$u ? Date.UTC(a.$y, S, $) : new Date(a.$y, S, $), a);
            return u ? M : M.endOf(b);
          }, s = function($, S) {
            return o.w(a.toDate()[$].apply(a.toDate("s"), (u ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(S)), a);
          }, f = this.$W, v = this.$M, w = this.$D, H = "set" + (this.$u ? "UTC" : "");
          switch (c) {
            case L:
              return u ? _(1, 0) : _(31, 11);
            case P:
              return u ? _(1, v) : _(0, v + 1);
            case x:
              var D = this.$locale().weekStart || 0, C = (f < D ? f + 7 : f) - D;
              return _(u ? w - C : w + (6 - C), v);
            case b:
            case R:
              return s(H + "Hours", 0);
            case k:
              return s(H + "Minutes", 1);
            case y:
              return s(H + "Seconds", 2);
            case m:
              return s(H + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, n.endOf = function(r) {
          return this.startOf(r, !1);
        }, n.$set = function(r, t) {
          var a, u = o.p(r), c = "set" + (this.$u ? "UTC" : ""), _ = (a = {}, a[b] = c + "Date", a[R] = c + "Date", a[P] = c + "Month", a[L] = c + "FullYear", a[k] = c + "Hours", a[y] = c + "Minutes", a[m] = c + "Seconds", a[h] = c + "Milliseconds", a)[u], s = u === b ? this.$D + (t - this.$W) : t;
          if (u === P || u === L) {
            var f = this.clone().set(R, 1);
            f.$d[_](s), f.init(), this.$d = f.set(R, Math.min(this.$D, f.daysInMonth())).$d;
          } else _ && this.$d[_](s);
          return this.init(), this;
        }, n.set = function(r, t) {
          return this.clone().$set(r, t);
        }, n.get = function(r) {
          return this[o.p(r)]();
        }, n.add = function(r, t) {
          var a, u = this;
          r = Number(r);
          var c = o.p(t), _ = function(v) {
            var w = g(u);
            return o.w(w.date(w.date() + Math.round(v * r)), u);
          };
          if (c === P) return this.set(P, this.$M + r);
          if (c === L) return this.set(L, this.$y + r);
          if (c === b) return _(1);
          if (c === x) return _(7);
          var s = (a = {}, a[y] = p, a[k] = E, a[m] = d, a)[c] || 1, f = this.$d.getTime() + r * s;
          return o.w(f, this);
        }, n.subtract = function(r, t) {
          return this.add(-1 * r, t);
        }, n.format = function(r) {
          var t = this, a = this.$locale();
          if (!this.isValid()) return a.invalidDate || ne;
          var u = r || "YYYY-MM-DDTHH:mm:ssZ", c = o.z(this), _ = this.$H, s = this.$m, f = this.$M, v = a.weekdays, w = a.months, H = a.meridiem, D = function(S, M, I, F) {
            return S && (S[M] || S(t, u)) || I[M].slice(0, F);
          }, C = function(S) {
            return o.s(_ % 12 || 12, S, "0");
          }, $ = H || function(S, M, I) {
            var F = S < 12 ? "AM" : "PM";
            return I ? F.toLowerCase() : F;
          };
          return u.replace(me, (function(S, M) {
            return M || (function(I) {
              switch (I) {
                case "YY":
                  return String(t.$y).slice(-2);
                case "YYYY":
                  return o.s(t.$y, 4, "0");
                case "M":
                  return f + 1;
                case "MM":
                  return o.s(f + 1, 2, "0");
                case "MMM":
                  return D(a.monthsShort, f, w, 3);
                case "MMMM":
                  return D(w, f);
                case "D":
                  return t.$D;
                case "DD":
                  return o.s(t.$D, 2, "0");
                case "d":
                  return String(t.$W);
                case "dd":
                  return D(a.weekdaysMin, t.$W, v, 2);
                case "ddd":
                  return D(a.weekdaysShort, t.$W, v, 3);
                case "dddd":
                  return v[t.$W];
                case "H":
                  return String(_);
                case "HH":
                  return o.s(_, 2, "0");
                case "h":
                  return C(1);
                case "hh":
                  return C(2);
                case "a":
                  return $(_, s, !0);
                case "A":
                  return $(_, s, !1);
                case "m":
                  return String(s);
                case "mm":
                  return o.s(s, 2, "0");
                case "s":
                  return String(t.$s);
                case "ss":
                  return o.s(t.$s, 2, "0");
                case "SSS":
                  return o.s(t.$ms, 3, "0");
                case "Z":
                  return c;
              }
              return null;
            })(S) || c.replace(":", "");
          }));
        }, n.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, n.diff = function(r, t, a) {
          var u, c = this, _ = o.p(t), s = g(r), f = (s.utcOffset() - this.utcOffset()) * p, v = this - s, w = function() {
            return o.m(c, s);
          };
          switch (_) {
            case L:
              u = w() / 12;
              break;
            case P:
              u = w();
              break;
            case ae:
              u = w() / 3;
              break;
            case x:
              u = (v - f) / 6048e5;
              break;
            case b:
              u = (v - f) / 864e5;
              break;
            case k:
              u = v / E;
              break;
            case y:
              u = v / p;
              break;
            case m:
              u = v / d;
              break;
            default:
              u = v;
          }
          return a ? u : o.a(u);
        }, n.daysInMonth = function() {
          return this.endOf(P).$D;
        }, n.$locale = function() {
          return N[this.$L];
        }, n.locale = function(r, t) {
          if (!r) return this.$L;
          var a = this.clone(), u = j(r, t, !0);
          return u && (a.$L = u), a;
        }, n.clone = function() {
          return o.w(this.$d, this);
        }, n.toDate = function() {
          return new Date(this.valueOf());
        }, n.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, n.toISOString = function() {
          return this.$d.toISOString();
        }, n.toString = function() {
          return this.$d.toUTCString();
        }, l;
      })(), ie = Y.prototype;
      return g.prototype = ie, [["$ms", h], ["$s", m], ["$m", y], ["$H", k], ["$W", b], ["$M", P], ["$y", L], ["$D", R]].forEach((function(l) {
        ie[l[1]] = function(n) {
          return this.$g(n, l[0], l[1]);
        };
      })), g.extend = function(l, n) {
        return l.$i || (l(n, Y, g), l.$i = !0), g;
      }, g.locale = j, g.isDayjs = q, g.unix = function(l) {
        return g(1e3 * l);
      }, g.en = N[O], g.Ls = N, g.p = {}, g;
    }));
  })(G)), G.exports;
}
var Le = we();
const X = /* @__PURE__ */ Se(Le), ee = {
  shop_id: 1,
  id: 1,
  created: "2021-09-29T09:00:00Z",
  modified: "2021-09-29T09:00:00Z",
  credentials: {
    client_id: "client_id",
    client_secret: "client_secret"
  },
  external_integration_provider_id: 1,
  reference_identifier: "reference_identifier",
  state: "state",
  credentiable_id: 1,
  version: "version",
  auto_import: 1,
  credentiable_type: "credentiable_type",
  expires: X().add(1, "year").unix()
}, kr = (e = {}) => ({
  ...ee,
  ...e
}), vr = (e = {}) => ({
  ...ee,
  ...e,
  expires: X().subtract(1, "year").unix()
}), hr = (e = {}) => ({
  ...ee,
  ...e,
  expires: X().add(1, "week").unix()
}), Pr = {
  id: 206,
  name: "Evening delivery",
  description: "Avondlevering",
  type: {
    id: 2,
    name: "Option"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205178,
      value: 200,
      country: null,
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Sr = {
  id: 207,
  name: "Morning delivery",
  description: "Ochtendlevering",
  type: {
    id: 2,
    name: "Option"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205660,
      value: 100,
      country: null,
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Er = {
  id: 1018,
  name: "Dm3 Refund 0-55",
  description: "Dm3 teruggave 0-55",
  type: {
    id: 4,
    name: "Refund"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205383,
      value: 100,
      country: "AT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205386,
      value: 100,
      country: "BE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205389,
      value: 100,
      country: "BG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205392,
      value: 100,
      country: "CY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205395,
      value: 100,
      country: "CZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205398,
      value: 100,
      country: "DE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205401,
      value: 100,
      country: "DK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205404,
      value: 100,
      country: "EE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205407,
      value: 100,
      country: "ES",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205410,
      value: 100,
      country: "FI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205413,
      value: 100,
      country: "FR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205416,
      value: 100,
      country: "GR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205419,
      value: 100,
      country: "HR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205422,
      value: 100,
      country: "HU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205425,
      value: 100,
      country: "IE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205428,
      value: 100,
      country: "IT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205431,
      value: 100,
      country: "LT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205434,
      value: 100,
      country: "LU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205437,
      value: 100,
      country: "LV",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205440,
      value: 100,
      country: "MC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205443,
      value: 100,
      country: "MT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205446,
      value: 100,
      country: "NL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205449,
      value: 100,
      country: "PL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205452,
      value: 100,
      country: "PT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205455,
      value: 100,
      country: "RO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205458,
      value: 100,
      country: "SE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205461,
      value: 100,
      country: "SI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205464,
      value: 100,
      country: "SK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, wr = {
  id: 1019,
  name: "Dm3 Refund 55-105",
  description: "Dm3 teruggave 55-105",
  type: {
    id: 4,
    name: "Refund"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205384,
      value: 200,
      country: "AT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205387,
      value: 200,
      country: "BE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205390,
      value: 200,
      country: "BG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205393,
      value: 200,
      country: "CY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205396,
      value: 200,
      country: "CZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205399,
      value: 200,
      country: "DE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205402,
      value: 200,
      country: "DK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205405,
      value: 200,
      country: "EE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205408,
      value: 200,
      country: "ES",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205411,
      value: 200,
      country: "FI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205414,
      value: 200,
      country: "FR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205417,
      value: 200,
      country: "GR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205420,
      value: 200,
      country: "HR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205423,
      value: 200,
      country: "HU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205426,
      value: 200,
      country: "IE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205429,
      value: 200,
      country: "IT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205432,
      value: 200,
      country: "LT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205435,
      value: 200,
      country: "LU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205438,
      value: 200,
      country: "LV",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205441,
      value: 200,
      country: "MC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205444,
      value: 200,
      country: "MT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205447,
      value: 200,
      country: "NL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205450,
      value: 200,
      country: "PL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205453,
      value: 200,
      country: "PT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205456,
      value: 200,
      country: "RO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205459,
      value: 200,
      country: "SE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205462,
      value: 200,
      country: "SI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205465,
      value: 200,
      country: "SK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Lr = {
  id: 1020,
  name: "Dm3 Refund 105-205",
  description: "Dm3 teruggave 105-205",
  type: {
    id: 4,
    name: "Refund"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205385,
      value: 300,
      country: "AT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205388,
      value: 300,
      country: "BE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205391,
      value: 300,
      country: "BG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205394,
      value: 300,
      country: "CY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205397,
      value: 300,
      country: "CZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205400,
      value: 300,
      country: "DE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205403,
      value: 300,
      country: "DK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205406,
      value: 300,
      country: "EE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205409,
      value: 300,
      country: "ES",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205412,
      value: 300,
      country: "FI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205415,
      value: 300,
      country: "FR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205418,
      value: 300,
      country: "GR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205421,
      value: 300,
      country: "HR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205424,
      value: 300,
      country: "HU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205427,
      value: 300,
      country: "IE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205430,
      value: 300,
      country: "IT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205433,
      value: 300,
      country: "LT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205436,
      value: 300,
      country: "LU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205439,
      value: 300,
      country: "LV",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205442,
      value: 300,
      country: "MC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205445,
      value: 300,
      country: "MT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205448,
      value: 300,
      country: "NL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205451,
      value: 300,
      country: "PL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205454,
      value: 300,
      country: "PT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205457,
      value: 300,
      country: "RO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205460,
      value: 300,
      country: "SE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205463,
      value: 300,
      country: "SI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205466,
      value: 300,
      country: "SK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Mr = {
  id: 304,
  name: "Insurance PostNL",
  description: "Verzekerd vanaf 500",
  type: {
    id: 2,
    name: "Option"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205706,
      value: 100,
      country: null,
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, xr = {
  id: 305,
  name: "Insurance PostNL EUR 100",
  description: "Verzekerd tot 100",
  type: {
    id: 2,
    name: "Option"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205703,
      value: 1e4,
      country: null,
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Nr = {
  id: 306,
  name: "Insurance PostNL EUR 250",
  description: "Verzekerd tot 250",
  type: {
    id: 2,
    name: "Option"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205704,
      value: 25e3,
      country: null,
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Dr = {
  id: 307,
  name: "Insurance PostNL EUR 500",
  description: "Verzekerd tot 500",
  type: {
    id: 2,
    name: "Option"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205705,
      value: 5e4,
      country: null,
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, $r = {
  id: 311,
  name: "Insurance PostNL EUR 500 Plus NL to BE",
  description: "Verzekerd vanaf 500 NL naar BE",
  type: {
    id: 2,
    name: "Option"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205707,
      value: 300,
      country: "BE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Tr = {
  id: 4906,
  name: "Bundle Max label discount",
  description: "Pakket Max label korting",
  type: "discount",
  category: {
    id: 1016,
    name: "Bundle label price adjustments"
  },
  prices: [
    {
      id: 39945,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1321,
        min: 0,
        max: null,
        number: 0,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39947,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1322,
        min: 0,
        max: null,
        number: 1,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39949,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1323,
        min: 0,
        max: null,
        number: 2,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39951,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1324,
        min: 0,
        max: null,
        number: 3,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39953,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1325,
        min: 0,
        max: null,
        number: 4,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39955,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1326,
        min: 0,
        max: null,
        number: 5,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    }
  ]
}, Rr = {
  id: 4900,
  name: "Bundle Start label discount",
  description: "Pakket Start label korting",
  type: "discount",
  category: {
    id: 1016,
    name: "Bundle label price adjustments"
  },
  prices: [
    {
      id: 39861,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1321,
        min: 0,
        max: null,
        number: 0,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39863,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1322,
        min: 0,
        max: null,
        number: 1,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39865,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1323,
        min: 0,
        max: null,
        number: 2,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39867,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1324,
        min: 0,
        max: null,
        number: 3,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39869,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1325,
        min: 0,
        max: null,
        number: 4,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39871,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1326,
        min: 0,
        max: null,
        number: 5,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    }
  ]
}, Hr = {
  id: 4902,
  name: "Bundle Plus label discount",
  description: "Pakket Plus label korting",
  type: "discount",
  category: {
    id: 1016,
    name: "Bundle label price adjustments"
  },
  prices: [
    {
      id: 39889,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1321,
        min: 0,
        max: null,
        number: 0,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39891,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1322,
        min: 0,
        max: null,
        number: 1,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39893,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1323,
        min: 0,
        max: null,
        number: 2,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39895,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1324,
        min: 0,
        max: null,
        number: 3,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39897,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1325,
        min: 0,
        max: null,
        number: 4,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39899,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1326,
        min: 0,
        max: null,
        number: 5,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    }
  ]
}, Ar = {
  id: 4904,
  name: "Bundle Premium label discount",
  description: "Pakket Premium label korting",
  type: "discount",
  category: {
    id: 1016,
    name: "Bundle label price adjustments"
  },
  prices: [
    {
      id: 39917,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1321,
        min: 0,
        max: null,
        number: 0,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39919,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1322,
        min: 0,
        max: null,
        number: 1,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39921,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1323,
        min: 0,
        max: null,
        number: 2,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39923,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1324,
        min: 0,
        max: null,
        number: 3,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39925,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1325,
        min: 0,
        max: null,
        number: 4,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    },
    {
      id: 39927,
      value: 40,
      country: null,
      platform_id: 1,
      bracket_range: {
        id: 1326,
        min: 0,
        max: null,
        number: 5,
        bracket_id: 1152,
        internal: !0
      },
      tier_range: null
    }
  ]
}, Or = {
  id: 102,
  name: "Shipment EU 1 & 2",
  description: "Pakket EU 1 & 2",
  type: {
    id: 1,
    name: "Shipment"
  },
  category: {
    id: 1,
    name: "Pakket EU PostNL"
  },
  prices: [
    {
      id: 205539,
      value: 200,
      country: "AT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205540,
      value: 200,
      country: "BG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205541,
      value: 200,
      country: "CZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205542,
      value: 200,
      country: "DK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205543,
      value: 200,
      country: "EE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205544,
      value: 200,
      country: "FI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205545,
      value: 200,
      country: "GR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205546,
      value: 200,
      country: "HU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205547,
      value: 200,
      country: "IE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205548,
      value: 200,
      country: "IT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205549,
      value: 200,
      country: "LT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205550,
      value: 200,
      country: "LU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205551,
      value: 200,
      country: "LV",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205552,
      value: 200,
      country: "PL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205553,
      value: 200,
      country: "PT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205554,
      value: 200,
      country: "RO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205555,
      value: 200,
      country: "SE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205556,
      value: 200,
      country: "SI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205557,
      value: 200,
      country: "SK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205558,
      value: 200,
      country: "CY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205559,
      value: 200,
      country: "MT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205560,
      value: 200,
      country: "HR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205561,
      value: 200,
      country: "MC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1010,
        min: 0,
        max: 2001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205609,
      value: 100,
      country: "AT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205610,
      value: 100,
      country: "BG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205611,
      value: 100,
      country: "CZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205612,
      value: 100,
      country: "DK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205613,
      value: 100,
      country: "EE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205614,
      value: 100,
      country: "FI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205615,
      value: 100,
      country: "GR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205616,
      value: 100,
      country: "HU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205617,
      value: 100,
      country: "IE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205618,
      value: 100,
      country: "IT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205619,
      value: 100,
      country: "LT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205620,
      value: 100,
      country: "LU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205621,
      value: 100,
      country: "LV",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205622,
      value: 100,
      country: "PL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205623,
      value: 100,
      country: "PT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205624,
      value: 100,
      country: "RO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205625,
      value: 100,
      country: "SE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205626,
      value: 100,
      country: "SI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205627,
      value: 100,
      country: "SK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205628,
      value: 100,
      country: "CY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205629,
      value: 100,
      country: "MT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205630,
      value: 100,
      country: "HR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205631,
      value: 100,
      country: "MC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1069,
        min: 20001,
        max: 23001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    }
  ]
}, Cr = {
  id: 109,
  name: "Shipment DE",
  description: "Pakket DE",
  type: {
    id: 1,
    name: "Shipment"
  },
  category: {
    id: 1,
    name: "Pakket EU PostNL"
  },
  prices: [
    {
      id: 205642,
      value: 700,
      country: "DE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1062,
        min: 2001,
        max: 5001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205644,
      value: 600,
      country: "DE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1012,
        min: 10001,
        max: 20001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    }
  ]
}, Ir = {
  id: 112,
  name: "Shipment ES",
  description: "Pakket ES",
  type: {
    id: 1,
    name: "Shipment"
  },
  category: {
    id: 1,
    name: "Pakket EU PostNL"
  },
  prices: [
    {
      id: 205643,
      value: 500,
      country: "ES",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1068,
        min: 5001,
        max: 10001,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    },
    {
      id: 205645,
      value: 800,
      country: "ES",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: {
        id: 1070,
        min: 23001,
        max: 31501,
        tier: {
          id: 1003,
          name: "weight"
        }
      }
    }
  ]
}, Br = {
  id: 6580,
  name: "DHL For You Pakket NL - S",
  description: "DHL For You Pakket NL - Small",
  type: {
    id: 1,
    name: "Shipment"
  },
  category: {
    id: 1019,
    name: "MyParcel Pakket NL DHL For You"
  },
  prices: [
    {
      id: 205656,
      value: 100,
      country: "NL",
      platform_id: 1,
      carrier_id: 9,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Ur = {
  id: 6581,
  name: "DHL For You Pakket NL - M",
  description: "DHL For You Pakket NL - Medium",
  type: {
    id: 1,
    name: "Shipment"
  },
  category: {
    id: 1019,
    name: "MyParcel Pakket NL DHL For You"
  },
  prices: [
    {
      id: 205657,
      value: 300,
      country: "NL",
      platform_id: 1,
      carrier_id: 9,
      bracket_range: null,
      tier_range: null
    }
  ]
}, jr = {
  id: 6589,
  name: "DHL For You Pakket BE - XXL",
  description: "DHL For You Pakket BE - Extra Extra Large",
  type: {
    id: 1,
    name: "Shipment"
  },
  category: {
    id: 1020,
    name: "MyParcel Pakket BE DHL For You"
  },
  prices: [
    {
      id: 205658,
      value: 300,
      country: "BE",
      platform_id: 1,
      carrier_id: 9,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Yr = {
  id: 6588,
  name: "DHL For You Pakket BE - XL",
  description: "DHL For You Pakket BE - Extra Large",
  type: {
    id: 1,
    name: "Shipment"
  },
  category: {
    id: 1020,
    name: "MyParcel Pakket BE DHL For You"
  },
  prices: [
    {
      id: 205659,
      value: 300,
      country: "BE",
      platform_id: 1,
      carrier_id: 9,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Fr = {
  id: 6582,
  name: "DHL For You Pakket NL - L",
  description: "DHL For You Pakket NL - Large",
  type: {
    id: 1,
    name: "Shipment"
  },
  category: {
    id: 1019,
    name: "MyParcel Pakket NL DHL For You"
  },
  prices: [
    {
      id: 205698,
      value: 400,
      country: "NL",
      platform_id: 1,
      carrier_id: 9,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Wr = {
  id: 1811,
  name: "Weight ROW",
  description: "Gewicht ROW",
  type: {
    id: 8,
    name: "Other"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205179,
      value: 700,
      country: "AE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205180,
      value: 700,
      country: "AF",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205181,
      value: 700,
      country: "AG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205182,
      value: 700,
      country: "AM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205183,
      value: 700,
      country: "AN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205184,
      value: 700,
      country: "AO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205185,
      value: 700,
      country: "AQ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205186,
      value: 700,
      country: "AR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205187,
      value: 700,
      country: "AW",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205188,
      value: 700,
      country: "AZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205189,
      value: 700,
      country: "BB",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205190,
      value: 700,
      country: "BD",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205191,
      value: 700,
      country: "BF",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205192,
      value: 700,
      country: "BH",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205193,
      value: 700,
      country: "BI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205194,
      value: 700,
      country: "BJ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205195,
      value: 700,
      country: "BM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205196,
      value: 700,
      country: "BN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205197,
      value: 700,
      country: "BO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205198,
      value: 700,
      country: "BQ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205199,
      value: 700,
      country: "BS",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205200,
      value: 700,
      country: "BT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205201,
      value: 700,
      country: "BW",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205202,
      value: 700,
      country: "BZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205203,
      value: 700,
      country: "CD",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205204,
      value: 700,
      country: "CF",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205205,
      value: 700,
      country: "CG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205206,
      value: 700,
      country: "CI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205207,
      value: 700,
      country: "CL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205208,
      value: 700,
      country: "CM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205209,
      value: 700,
      country: "CO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205210,
      value: 700,
      country: "CR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205211,
      value: 700,
      country: "CU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205212,
      value: 700,
      country: "CV",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205213,
      value: 700,
      country: "CW",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205214,
      value: 700,
      country: "DJ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205215,
      value: 700,
      country: "DM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205216,
      value: 700,
      country: "DO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205217,
      value: 700,
      country: "DZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205218,
      value: 700,
      country: "EC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205219,
      value: 700,
      country: "EG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205220,
      value: 700,
      country: "ER",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205221,
      value: 700,
      country: "ET",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205222,
      value: 700,
      country: "FJ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205223,
      value: 700,
      country: "FK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205224,
      value: 700,
      country: "GA",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205225,
      value: 700,
      country: "GD",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205226,
      value: 700,
      country: "GE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205227,
      value: 700,
      country: "GF",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205228,
      value: 700,
      country: "GH",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205229,
      value: 700,
      country: "GM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205230,
      value: 700,
      country: "GN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205231,
      value: 700,
      country: "GP",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205232,
      value: 700,
      country: "GQ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205233,
      value: 700,
      country: "GT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205234,
      value: 700,
      country: "GW",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205235,
      value: 700,
      country: "GY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205236,
      value: 700,
      country: "HN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205237,
      value: 700,
      country: "HT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205238,
      value: 700,
      country: "ID",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205239,
      value: 700,
      country: "IL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205240,
      value: 700,
      country: "IN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205241,
      value: 700,
      country: "IQ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205242,
      value: 700,
      country: "IR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205243,
      value: 700,
      country: "JM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205244,
      value: 700,
      country: "JO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205245,
      value: 700,
      country: "KE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205246,
      value: 700,
      country: "KG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205247,
      value: 700,
      country: "KH",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205248,
      value: 700,
      country: "KI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205249,
      value: 700,
      country: "KM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205250,
      value: 700,
      country: "KN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205251,
      value: 700,
      country: "KR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205252,
      value: 700,
      country: "KW",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205253,
      value: 700,
      country: "KY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205254,
      value: 700,
      country: "KZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205255,
      value: 700,
      country: "LA",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205256,
      value: 700,
      country: "LB",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205257,
      value: 700,
      country: "LC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205258,
      value: 700,
      country: "LK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205259,
      value: 700,
      country: "LR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205260,
      value: 700,
      country: "LS",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205261,
      value: 700,
      country: "LY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205262,
      value: 700,
      country: "MA",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205263,
      value: 700,
      country: "MG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205264,
      value: 700,
      country: "ML",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205265,
      value: 700,
      country: "MM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205266,
      value: 700,
      country: "MN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205267,
      value: 700,
      country: "MO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205268,
      value: 700,
      country: "MQ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205269,
      value: 700,
      country: "MR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205270,
      value: 700,
      country: "MS",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205271,
      value: 700,
      country: "MU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205272,
      value: 700,
      country: "MV",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205273,
      value: 700,
      country: "MW",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205274,
      value: 700,
      country: "MX",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205275,
      value: 700,
      country: "MY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205276,
      value: 700,
      country: "MZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205277,
      value: 700,
      country: "NA",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205278,
      value: 700,
      country: "NC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205279,
      value: 700,
      country: "NE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205280,
      value: 700,
      country: "NG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205281,
      value: 700,
      country: "NI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205282,
      value: 700,
      country: "NP",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205283,
      value: 700,
      country: "NR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205284,
      value: 700,
      country: "OM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205285,
      value: 700,
      country: "PA",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205286,
      value: 700,
      country: "PE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205287,
      value: 700,
      country: "PF",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205288,
      value: 700,
      country: "PG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205289,
      value: 700,
      country: "PH",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205290,
      value: 700,
      country: "PK",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205291,
      value: 700,
      country: "PM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205292,
      value: 700,
      country: "PN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205293,
      value: 700,
      country: "PR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205294,
      value: 700,
      country: "PY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205295,
      value: 700,
      country: "QA",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205296,
      value: 700,
      country: "RE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205297,
      value: 700,
      country: "RU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205298,
      value: 700,
      country: "RW",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205299,
      value: 700,
      country: "SA",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205300,
      value: 700,
      country: "SC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205301,
      value: 700,
      country: "SD",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205302,
      value: 700,
      country: "SG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205303,
      value: 700,
      country: "SL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205304,
      value: 700,
      country: "SN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205305,
      value: 700,
      country: "SO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205306,
      value: 700,
      country: "SR",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205307,
      value: 700,
      country: "ST",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205308,
      value: 700,
      country: "SV",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205309,
      value: 700,
      country: "SX",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205310,
      value: 700,
      country: "SY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205311,
      value: 700,
      country: "SZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205312,
      value: 700,
      country: "TC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205313,
      value: 700,
      country: "TD",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205314,
      value: 700,
      country: "TG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205315,
      value: 700,
      country: "TH",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205316,
      value: 700,
      country: "TJ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205317,
      value: 700,
      country: "TL",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205318,
      value: 700,
      country: "TM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205319,
      value: 700,
      country: "TN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205320,
      value: 700,
      country: "TO",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205321,
      value: 700,
      country: "TT",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205322,
      value: 700,
      country: "TV",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205323,
      value: 700,
      country: "TW",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205324,
      value: 700,
      country: "TZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205325,
      value: 700,
      country: "UG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205326,
      value: 700,
      country: "UY",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205327,
      value: 700,
      country: "UZ",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205328,
      value: 700,
      country: "VC",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205329,
      value: 700,
      country: "VE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205330,
      value: 700,
      country: "VG",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205331,
      value: 700,
      country: "VI",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205332,
      value: 700,
      country: "VN",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205333,
      value: 700,
      country: "VU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205334,
      value: 700,
      country: "WS",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205335,
      value: 700,
      country: "YE",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205336,
      value: 700,
      country: "ZM",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    },
    {
      id: 205337,
      value: 700,
      country: "ZW",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, Vr = {
  id: 1801,
  name: "Weight US",
  description: "Gewicht US",
  type: {
    id: 8,
    name: "Other"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205175,
      value: 100,
      country: "US",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
}, zr = {
  id: 1802,
  name: "Weight AU",
  description: "Gewicht AU",
  type: {
    id: 8,
    name: "Other"
  },
  category: {
    id: null,
    name: null
  },
  prices: [
    {
      id: 205176,
      value: 100,
      country: "AU",
      platform_id: 1,
      carrier_id: 1,
      bracket_range: null,
      tier_range: null
    }
  ]
};
var T = { PostNl: 1, DhlForYou: 9 }, Me = { PostNl: "postnl" }, xe = { Standard: 2 }, ce = { Package: 1 }, Q = { SendMyParcel: 3 }, Ne = { Main: "main" }, De = { Completed: "completed" };
const $e = {
  id: 1,
  description: "customer_marketing",
  name: "customer_marketing",
  role_type: "customer"
}, Te = {
  id: 1,
  account_id: 692,
  username: "unit@myparcel.nl",
  created: "2023-10-19 13:03:24",
  remember_token: null,
  all_shop_access: !0,
  status: "active",
  contact: {
    id: 777,
    gender: "mr",
    first_name: "Pietje",
    last_name: "Puk",
    email: "unit@myparcel.nl",
    phone: "0612345678",
    company: null,
    street: "",
    number: "",
    number_suffix: "",
    box_number: "",
    postal_code: "",
    city: "",
    cc: null,
    street_additional_info: "",
    region: ""
  },
  roles: [$e]
}, Re = {
  id: 1,
  contact_id: 777,
  platform_id: 1,
  origin_id: 1,
  status: 1,
  terms_agreed: !0,
  username: "unit@myparcel.nl",
  first_name: "Pietje",
  last_name: "Puk",
  gender: "mr",
  email: "unit@myparcel.nl",
  phone: "0612345678",
  general_settings: {
    affiliate_bcc: 0,
    affiliate_fee: {
      amount: 10,
      currency: "EUR"
    },
    order_mode: 0,
    is_test: 0
  },
  additional_info: {
    coupon: ""
  },
  shipment_estimates: [
    {
      region: "NL",
      package_type: 1,
      estimate: 50
    }
  ],
  delivery_address: null,
  created: "2023-10-19 13:03:24",
  modified: "2023-10-19 13:03:24",
  carrier_references: [],
  contact: {
    id: 777,
    gender: "mr",
    first_name: "Pietje",
    last_name: "Puk",
    email: "unit@myparcel.nl",
    phone: "0612345678",
    company: null,
    street: "",
    number: "",
    number_suffix: "",
    box_number: "",
    postal_code: "",
    city: "",
    cc: null,
    street_additional_info: "",
    region: ""
  },
  shops: [
    {
      id: 1,
      account_id: 692,
      platform_id: 1,
      name: "http://harmful-fund.biz1697713399325",
      hidden: 0,
      billing: {
        address: {
          email: "unit@myparcel.nl",
          phone: "0612345678",
          company: "Myparcel",
          postal_code: "2132WT",
          number: "66",
          street: "Siriusdreef",
          street_additional_info: "",
          city: "Hoofddorp",
          cc: "NL",
          person: "Pietje Puk"
        },
        billing_method: 2,
        cc_main_email_in_billing_emails: 1,
        cycle: "weekly",
        legal_name: "Myparcel B.V.",
        coc: "12345678",
        vat_number: "",
        iban: "",
        eori_number: "",
        vat_tariff: 210,
        vat_type: "general"
      },
      return: {
        link_expires_after: 28,
        bcc: 0,
        use_shop_shipment_options: 0,
        send_tracktrace_email_for_return_shipments: 0,
        email_address_for_tracktrace_return_shipments: null,
        use_custom_description: 0,
        from_address_name: "",
        use_printerless_return: 0,
        settle_printerless_return_cost: 0,
        address: {
          email: "unit@myparcel.nl",
          phone: "0612345678",
          company: "Myparcel",
          postal_code: "2132WT",
          number: "66",
          street: "Siriusdreef",
          street_additional_info: "",
          city: "Hoofddorp",
          cc: "NL",
          person: "Pietje Puk"
        }
      },
      delivery_address: {
        gender: "mr",
        first_name: "Pietje",
        last_name: "Puk",
        email: "unit@myparcel.nl",
        phone: "0612345678",
        company: "Myparcel",
        postal_code: "2132WT",
        number: "66",
        street: "Siriusdreef",
        street_additional_info: "",
        city: "Hoofddorp",
        cc: "NL"
      },
      tracktrace: {
        delivery_notification: 0,
        send_track_trace_emails: 0,
        email_on_handed_to_courier: 1,
        carrier_email_basic_notification: 1,
        bcc: 0,
        from_address_email: "unit@myparcel.nl",
        from_address_company: "Myparcel"
      },
      general_settings: {
        auto_save_addresses: 1,
        reminder_email: 0,
        use_logo_label: 0,
        label_format: "A4",
        weight: 1e3,
        preferred_locale: "nl-NL"
      },
      shipment_options: {
        package_type: 1,
        signature: 0,
        only_recipient: 0,
        insurance: {
          amount: 0,
          currency: "EUR"
        },
        large_format: 0,
        age_check: 0,
        return: 0,
        collect: 0,
        drop_off_at_postal_point: 0,
        saturday_delivery: 0,
        same_day_delivery: 0,
        printerless_return: 0,
        extra_assurance: 0,
        hide_sender: 0,
        label_description: null
      },
      created: "2023-10-19 13:03:25",
      modified: "2023-10-19 13:03:25",
      branding: null,
      return_reason_settings: null
    },
    {
      id: 2,
      account_id: 692,
      platform_id: 1,
      name: "secondary-emails-http://harmful-fund.biz1697713399325-1697713410",
      hidden: 0,
      billing: {
        address: {
          email: "unit@myparcel.nl",
          phone: "0612345678",
          company: "Myparcel",
          postal_code: "2132WT",
          number: "66",
          street: "Siriusdreef",
          street_additional_info: "",
          city: "Hoofddorp",
          cc: "NL",
          person: "Pietje Puk"
        },
        billing_method: 2,
        cc_main_email_in_billing_emails: 1,
        cycle: "weekly",
        legal_name: "Myparcel B.V.",
        coc: "12345678",
        vat_number: "",
        iban: "",
        eori_number: "",
        vat_tariff: 210,
        vat_type: "general"
      },
      return: {
        link_expires_after: 28,
        bcc: 0,
        use_shop_shipment_options: 0,
        send_tracktrace_email_for_return_shipments: 0,
        email_address_for_tracktrace_return_shipments: null,
        use_custom_description: 0,
        from_address_name: "",
        use_printerless_return: 0,
        settle_printerless_return_cost: 0,
        address: {
          email: "unit@myparcel.nl",
          phone: "0612345678",
          company: "Myparcel",
          postal_code: "2132WT",
          number: "66",
          street: "Siriusdreef",
          street_additional_info: "",
          city: "Hoofddorp",
          cc: "NL",
          person: "Pietje Puk"
        }
      },
      delivery_address: {
        gender: "mr",
        first_name: "Pietje",
        last_name: "Puk",
        email: "unit@myparcel.nl",
        phone: "0612345678",
        company: "Myparcel",
        postal_code: "2132WT",
        number: "66",
        street: "Siriusdreef",
        street_additional_info: "",
        city: "Hoofddorp",
        cc: "NL"
      },
      tracktrace: {
        delivery_notification: 0,
        send_track_trace_emails: 0,
        email_on_handed_to_courier: 1,
        carrier_email_basic_notification: 1,
        bcc: 0,
        from_address_email: "unit@myparcel.nl",
        from_address_company: "Myparcel"
      },
      general_settings: {
        auto_save_addresses: 1,
        reminder_email: 0,
        use_logo_label: 0,
        label_format: "A4",
        weight: 1e3,
        preferred_locale: "nl-NL"
      },
      shipment_options: {
        package_type: 1,
        signature: 0,
        only_recipient: 0,
        insurance: {
          amount: 0,
          currency: "EUR"
        },
        large_format: 0,
        age_check: 0,
        return: 0,
        collect: 0,
        drop_off_at_postal_point: 0,
        saturday_delivery: 0,
        same_day_delivery: 0,
        printerless_return: 0,
        extra_assurance: 0,
        hide_sender: 0,
        label_description: null
      },
      created: "2023-10-19 13:03:30",
      modified: "2023-10-19 13:03:30",
      branding: null,
      return_reason_settings: null
    }
  ],
  users: [Te]
}, Gr = (e = {}) => ({
  ...Re,
  ...e
}), He = {
  account_id: 1,
  carrier_id: T.PostNl,
  created: "2023-10-19 13:03:24",
  id: 1,
  modified: "2023-10-19 13:03:24",
  reference_identifier: "reference123456"
}, Kr = (e = {}) => ({
  ...He,
  ...e
}), Zr = {
  id: 1,
  contact_id: 777,
  platform_id: Q.SendMyParcel,
  origin_id: 1,
  status: 1,
  terms_agreed: !0,
  username: "unit@myparcel.nl",
  first_name: "Pietje",
  last_name: "Puk",
  gender: "mr",
  email: "unit@myparcel.nl",
  phone: "0612345678",
  general_settings: {
    affiliate_bcc: 0,
    affiliate_fee: {
      amount: 10,
      currency: "EUR"
    },
    order_mode: 0,
    allow_printerless_return: 1,
    is_test: 0
  },
  additional_info: {
    coupon: ""
  },
  shipment_estimates: [
    {
      region: "NL",
      package_type: 1,
      estimate: 50
    }
  ],
  delivery_address: null,
  created: "2023-10-19 13:03:24",
  modified: "2023-10-19 13:03:24",
  carrier_references: [],
  contact: {
    id: 777,
    gender: "mr",
    first_name: "Pietje",
    last_name: "Puk",
    email: "unit@myparcel.nl",
    phone: "0612345678",
    company: null,
    street: "",
    number: "",
    number_suffix: "",
    box_number: "",
    postal_code: "",
    city: "",
    cc: null,
    street_additional_info: "",
    region: ""
  },
  shops: [
    {
      id: 1,
      account_id: 692,
      platform_id: Q.SendMyParcel,
      name: "http://harmful-fund.biz1697713399325",
      hidden: 0,
      billing: {
        address: {
          email: "unit@myparcel.nl",
          phone: "0612345678",
          company: "Myparcel",
          postal_code: "2132WT",
          number: "66",
          street: "Siriusdreef",
          street_additional_info: "",
          city: "Hoofddorp",
          cc: "NL",
          person: "Pietje Puk"
        },
        billing_method: 2,
        cc_main_email_in_billing_emails: 1,
        cycle: "weekly",
        legal_name: "Myparcel B.V.",
        coc: "12345678",
        vat_number: "",
        iban: "",
        eori_number: "",
        vat_tariff: 210,
        vat_type: "general"
      },
      return: {
        link_expires_after: 28,
        bcc: 0,
        use_shop_shipment_options: 0,
        send_tracktrace_email_for_return_shipments: 0,
        email_address_for_tracktrace_return_shipments: null,
        use_custom_description: 0,
        from_address_name: "",
        use_printerless_return: 0,
        settle_printerless_return_cost: 0,
        address: {
          email: "unit@myparcel.nl",
          phone: "0612345678",
          company: "Myparcel",
          postal_code: "2132WT",
          number: "66",
          street: "Siriusdreef",
          street_additional_info: "",
          city: "Hoofddorp",
          cc: "NL",
          person: "Pietje Puk"
        }
      },
      delivery_address: {
        gender: "mr",
        first_name: "Pietje",
        last_name: "Puk",
        email: "unit@myparcel.nl",
        phone: "0612345678",
        company: "Myparcel",
        postal_code: "2132WT",
        number: "66",
        street: "Siriusdreef",
        street_additional_info: "",
        city: "Hoofddorp",
        cc: "NL"
      },
      tracktrace: {
        delivery_notification: 0,
        send_track_trace_emails: 0,
        email_on_handed_to_courier: 1,
        carrier_email_basic_notification: 1,
        bcc: 0,
        from_address_email: "unit@myparcel.nl",
        from_address_company: "Myparcel"
      },
      general_settings: {
        auto_save_addresses: 1,
        reminder_email: 0,
        use_logo_label: 0,
        label_format: "A4",
        weight: 1e3,
        preferred_locale: "nl-NL"
      },
      shipment_options: {
        package_type: 1,
        signature: 0,
        only_recipient: 0,
        insurance: {
          amount: 0,
          currency: "EUR"
        },
        large_format: 0,
        age_check: 0,
        return: 0,
        collect: 0,
        drop_off_at_postal_point: 0,
        saturday_delivery: 0,
        same_day_delivery: 0,
        printerless_return: 0,
        extra_assurance: 0,
        hide_sender: 0,
        label_description: null
      },
      created: "2023-10-19 13:03:25",
      modified: "2023-10-19 13:03:25",
      branding: null,
      return_reason_settings: null
    },
    {
      id: 2,
      account_id: 692,
      platform_id: Q.SendMyParcel,
      name: "secondary-emails-http://harmful-fund.biz1697713399325-1697713410",
      hidden: 0,
      billing: {
        address: {
          email: "unit@myparcel.nl",
          phone: "0612345678",
          company: "Myparcel",
          postal_code: "2132WT",
          number: "66",
          street: "Siriusdreef",
          street_additional_info: "",
          city: "Hoofddorp",
          cc: "NL",
          person: "Pietje Puk"
        },
        billing_method: 2,
        cc_main_email_in_billing_emails: 1,
        cycle: "weekly",
        legal_name: "Myparcel B.V.",
        coc: "12345678",
        vat_number: "",
        iban: "",
        eori_number: "",
        vat_tariff: 210,
        vat_type: "general"
      },
      return: {
        link_expires_after: 28,
        bcc: 0,
        use_shop_shipment_options: 0,
        send_tracktrace_email_for_return_shipments: 0,
        email_address_for_tracktrace_return_shipments: null,
        use_custom_description: 0,
        from_address_name: "",
        use_printerless_return: 0,
        settle_printerless_return_cost: 0,
        address: {
          email: "unit@myparcel.nl",
          phone: "0612345678",
          company: "Myparcel",
          postal_code: "2132WT",
          number: "66",
          street: "Siriusdreef",
          street_additional_info: "",
          city: "Hoofddorp",
          cc: "NL",
          person: "Pietje Puk"
        }
      },
      delivery_address: {
        gender: "mr",
        first_name: "Pietje",
        last_name: "Puk",
        email: "unit@myparcel.nl",
        phone: "0612345678",
        company: "Myparcel",
        postal_code: "2132WT",
        number: "66",
        street: "Siriusdreef",
        street_additional_info: "",
        city: "Hoofddorp",
        cc: "NL"
      },
      tracktrace: {
        delivery_notification: 0,
        send_track_trace_emails: 0,
        email_on_handed_to_courier: 1,
        carrier_email_basic_notification: 1,
        bcc: 0,
        from_address_email: "unit@myparcel.nl",
        from_address_company: "Myparcel"
      },
      general_settings: {
        auto_save_addresses: 1,
        reminder_email: 0,
        use_logo_label: 0,
        label_format: "A4",
        weight: 1e3,
        preferred_locale: "nl-NL"
      },
      shipment_options: {
        package_type: 1,
        signature: 0,
        only_recipient: 0,
        insurance: {
          amount: 0,
          currency: "EUR"
        },
        large_format: 0,
        age_check: 0,
        return: 0,
        collect: 0,
        drop_off_at_postal_point: 0,
        saturday_delivery: 0,
        same_day_delivery: 0,
        printerless_return: 0,
        extra_assurance: 0,
        hide_sender: 0,
        label_description: null
      },
      created: "2023-10-19 13:03:30",
      modified: "2023-10-19 13:03:30",
      branding: null,
      return_reason_settings: null
    }
  ],
  users: [
    {
      id: 1,
      account_id: 692,
      username: "unit@myparcel.nl",
      created: "2023-10-19 13:03:24",
      remember_token: null,
      all_shop_access: !0,
      status: "active",
      contact: {
        id: 777,
        gender: "mr",
        first_name: "Pietje",
        last_name: "Puk",
        email: "unit@myparcel.nl",
        phone: "0612345678",
        company: null,
        street: "",
        number: "",
        number_suffix: "",
        box_number: "",
        postal_code: "",
        city: "",
        cc: null,
        street_additional_info: "",
        region: ""
      }
    }
  ]
}, Ae = {
  cc: "NL",
  city: "Hoofddorp",
  email: "unit@myparcel.nl",
  number: "31",
  number_suffix: "",
  person: "John Doe",
  phone: "0612345678",
  postal_code: "2131JE",
  street: "Antareslaan",
  street_additional_info: "",
  company: ""
}, ue = (e = {}) => ({
  ...Ae,
  ...e
}), Oe = {
  bracket_range: {
    bracket_id: 1,
    // should be the same as the id in the root object
    description: null,
    id: 2,
    max: 250,
    min: 1,
    name: null,
    number: 1
  },
  carrier_id: T.PostNl,
  id: 1,
  name: "bracket name",
  package_type: ce.Package,
  product_category_id: 1,
  product_id: 3,
  region: "ROW",
  shipment_type: 1
}, Jr = (e = {}) => ({
  ...Oe,
  ...e
}), U = "unittest", Ce = {
  use_consumer_portal: !0,
  enable_track_trace: !0,
  enable_returns: !0,
  accent_color: "#0f7859",
  subdomain: U,
  logo: "staticv2/images/myparcel-logo-small.svg"
}, qr = (e = {}) => ({
  ...Ce,
  ...e
}), Qr = {
  carrier_id: T.PostNl,
  configuration: {
    default_cutoff_time: "17:00",
    monday_cutoff_time: "17:00"
  }
}, Xr = {
  carrier_id: T.DhlForYou,
  configuration: {
    default_cutoff_time: "17:00",
    monday_cutoff_time: "17:00"
  }
}, Ie = {
  id: 1,
  label: void 0,
  carrier_id: T.PostNl,
  carrier: {
    id: T.PostNl,
    name: Me.PostNl
  },
  enabled: 1,
  optional: 0,
  primary: 1,
  type: Ne.Main,
  subscription_id: void 0,
  options: {
    customerCode: "MYPO",
    customerNumber: "123456",
    customerCollectionLocation: "100123",
    barcodeOptions: { gpType: "CF", gpRange: "4567" },
    serviceLevels: 1
  },
  username: "username",
  password: "password",
  api_key: "a1b2c3d4e5f6g7"
}, ea = (e = {}) => ({
  ...Ie,
  ...e
}), Be = {
  id: 2,
  collect_trip_schedule_id: 1,
  shop_id: 18,
  contact_id: 45,
  carrier_id: 1,
  carrier_reference: "000273e1-a5cb-4bdf-ba8a-b71312948f05",
  order_reference: null,
  collect_window_start_datetime: "2025-05-12 10:00:00",
  collect_window_end_datetime: "2025-05-12 12:00:00",
  width: 1,
  height: 1,
  length: 1,
  weight: 1,
  status: "new",
  created: "2017-06-15 11:30:01",
  modified: "2017-11-20 09:22:44",
  collect_trip_planning_id: null,
  volume_type: "package",
  volume: 5,
  notes: null,
  courier_product_id: 1,
  final_tracktrace_status: null,
  packaging_replenishment: !1,
  history: [],
  type: "structural",
  price: {
    amount: 725,
    currency: "EUR"
  },
  courier_product: {
    id: 1,
    name: "collect_service_loose_loading",
    description: "Haalservice loose-loading",
    courier_id: 1,
    editable: !0
  },
  contact: {
    id: 45,
    gender: "mr",
    first_name: "John",
    last_name: "Doe",
    email: "customer@myparcel.nl",
    phone: "0233030315",
    company: "MyParcel",
    street: "",
    number: "",
    number_suffix: "",
    box_number: "",
    postal_code: "",
    city: "",
    cc: null,
    street_additional_info: "",
    region: ""
  }
}, ra = (e = {}) => ({
  ...Be,
  ...e
}), Ue = {
  id: 2,
  shop_id: 18,
  contact_id: 43,
  carrier_id: 1,
  day_of_the_week: 2,
  planning_start_date: "2025-06-08 00:00:00",
  planning_end_date: null,
  collect_window_start_time: "16:00:00",
  collect_window_end_time: "17:00:00",
  created: "2025-07-08 08:47:50",
  modified: "2025-07-08 08:47:50",
  collect_trip_planning_id: null,
  volume_type: "package",
  volume: 1,
  notes: null,
  courier_product_id: 1,
  carrier_reference: null,
  status: "new",
  packaging_replenishment: !1,
  contact: {
    id: 43,
    gender: "mr",
    first_name: "John",
    last_name: "Doe",
    email: "customer@myparcel.nl",
    phone: "0233030315",
    company: "MyParcel",
    street: "",
    number: "",
    number_suffix: "",
    box_number: "",
    postal_code: "",
    city: "",
    cc: null,
    street_additional_info: "",
    region: ""
  }
}, aa = (e = {}) => ({
  ...Ue,
  ...e
}), je = {
  id: 1,
  date: "2025-01-01",
  from_time: "12:00",
  to_time: "16:00",
  whole_day: !1,
  created: "2025-07-07 14:45:42",
  modified: "2025-07-07 14:45:42",
  reason: "Because I like it"
}, na = (e = {}) => ({
  ...je,
  ...e
}), Ye = {
  banner_action_title: "",
  banner_action_url: "",
  review_url: "",
  social_widget: {
    type: "none",
    identifier: ""
  },
  social_links: {
    facebook: "",
    twitter: "",
    instagram: "",
    youtube: "",
    tiktok: "",
    linkedin: ""
  },
  company: {
    name: "MyParcel",
    cc: "NL",
    street: "Antareslaan 31",
    street_additional_info: "",
    postal_code: "2132JE",
    city: "Hoofddorp",
    email: "info@myparcel.nl",
    phone: "0233030315"
  },
  returns: {
    introduction: "<p>Voldoen de producten niet aan uw verwachtingen? Terugsturen kan!<br />Met het retourlabel kunt u uw bestelling retourneren.</p>"
  },
  banner_button_enabled: "0",
  language: "nl_NL",
  shop_id: 2219,
  banner_path: null
}, ta = (e = {}) => ({
  ...Ye,
  ...e
}), Fe = {
  status: De.Completed,
  reason: "",
  reason_code: "",
  paid: 1,
  payment_initiation_url: "unittest.myparcel.me"
}, ia = (e = {}) => ({
  ...Fe,
  ...e
}), We = {
  enabled: !0,
  mandatory: !1,
  return_reasons: [
    {
      name: "damaged",
      human: "Artikel(en) is/zijn beschadigd"
    },
    {
      name: "changed_my_mind",
      human: "Ik heb me bedacht"
    },
    {
      name: "color_not_as_expected",
      human: "De kleur is anders dan ik had verwacht"
    },
    {
      name: "delivered_too_late",
      human: "Ik heb het artikel niet op tijd ontvangen"
    },
    {
      name: "dont_need_it_anymore",
      human: "Ik heb het artikel niet meer nodig"
    },
    {
      name: "ordered_multiple_products",
      human: "Ik heb meerdere artikelen besteld, de juiste houd ik"
    },
    {
      name: "ordered_wrong_product",
      human: "Ik heb het verkeerde product besteld"
    },
    {
      name: "product_not_as_expected",
      human: "Het artikel komt niet overeen met afbeelding/productinformatie"
    },
    {
      name: "quality_not_as_expected",
      human: "Ik had een hogere kwaliteit verwacht"
    },
    {
      name: "received_wrong_product",
      human: "Verkeerde artikel(en) ontvangen"
    },
    {
      name: "received_wrong_size",
      human: "Ik heb de verkeerde maat/afmeting ontvangen"
    },
    {
      name: "product_cheaper_elsewhere",
      human: "Het artikel is elders goedkoper"
    },
    {
      name: "product_incomplete",
      human: "Het artikel is incompleet"
    },
    {
      name: "product_not_functional",
      human: "Het artikel werkt niet"
    }
  ]
}, la = (e = {}) => ({
  ...We,
  ...e
}), Ve = {
  hash: "6e2569a3837fa4b80170be8431665e9c",
  email: {
    email: null,
    name: "Pietje Puk"
  },
  created: {
    date: "2024-06-05 18:01:35.000000",
    timezone_type: 3,
    timezone: "Europe/Amsterdam"
  },
  expire: {
    date: "2024-07-03 18:01:35.000000",
    timezone_type: 3,
    timezone: "Europe/Amsterdam"
  },
  email_label: null,
  has_printerless_return: !1,
  link_consumer_portal: `https://${U}.myparcel.me/returns/6e2569a3837fa4b80170be8431665e9c`,
  carrier: {
    id: 1,
    name: "PostNL",
    location_picker_url: "https://www.postnl.nl/locatiewijzer/"
  },
  payment_instructions: {
    id: "0f2feb188e527a532aef74b2c4915bb269c2fdd1",
    hash: "0f2feb188e527a532aef74b2c4915bb269c2fdd1",
    invoices: {
      id: 9767,
      number: "C240000004",
      status: 101
    },
    type: 2,
    notification_hash: "0c50463782310405ccd334352da8c9250c58e6b7",
    original_notification_hash: "0c50463782310405ccd334352da8c9250c58e6b7",
    paid: 0,
    price: {
      amount: 1266,
      currency: "EUR"
    },
    payment_url: "https://testpayv2.multisafepay.com/connect/823Ie88ANwCdCi80xibPi2xP2s5dZQ8ZKhs/?lang=nl_NL"
  },
  related_shipment_data: {
    barcode: "3SMYPA778022083",
    postal_code: "2134VP",
    cc: "NL"
  }
}, ua = (e = {}) => ({
  ...Ve,
  ...e
}), ze = {
  uuid: "667102df-5c43-49cd-9783-d72ed09c2b3a",
  shop_id: 18,
  generated_shipment_id: null,
  shipment_options: {
    reference_identifier: "",
    options: {
      package_type: 1,
      only_recipient: 0,
      collect: 0,
      drop_off_at_postal_point: 0,
      age_check: 0,
      signature: 0,
      return: 0,
      insurance: {
        amount: 0,
        currency: "EUR"
      },
      large_format: 0,
      saturday_delivery: 0,
      label_description: "",
      delivery_type: 2
    },
    physical_properties: {
      weight: 1e3
    },
    carrier: 1,
    contract_id: 1,
    recipient: {
      cc: "NL"
    }
  },
  link_track_trace: null,
  link_consumer_portal: `https://${U}.myparcel.me/returns/6e2569a3837fa4b80170be8431665e9c`,
  expires_at: {
    date: "2024-09-16 15:30:33.000000",
    timezone_type: 3,
    timezone: "Europe/Amsterdam"
  },
  created_at: {
    date: "2024-09-02 15:30:33.000000",
    timezone_type: 3,
    timezone: "Europe/Amsterdam"
  },
  updated_at: {
    date: "2024-09-02 15:30:33.000000",
    timezone_type: 3,
    timezone: "Europe/Amsterdam"
  }
}, ca = (e = {}) => ({
  ...ze,
  ...e
}), Ge = {
  id: 1,
  price: {
    amount: 2164,
    currency: "EUR"
  },
  price_after_vat: {
    amount: 2618,
    currency: "EUR"
  },
  vat: {
    amount: 454,
    currency: "EUR"
  },
  amount_due: {
    amount: 0,
    currency: "EUR"
  },
  transactions: [
    {
      invoice_id: 1,
      transaction_id: 24000091,
      price: {
        amount: 2618,
        currency: "EUR"
      },
      transaction_date: "2024-12-18",
      status: 1,
      type: 2,
      description: null,
      created_by_admin: {
        account_id: null,
        username: null,
        first_name: null,
        last_name: null
      },
      cancelled_by_admin: {
        account_id: null,
        username: null,
        first_name: null,
        last_name: null
      },
      cancelled_at: null,
      parent_transaction_id: null
    }
  ],
  status: 506,
  billing: {
    address: {
      email: "remco+testing@myparcel.nl",
      phone: "0634207712",
      company: "",
      postal_code: "2151dp",
      number: "1",
      street: "Polanen",
      street_additional_info: "",
      city: "Nieuw-Vennep",
      cc: "NL",
      person: "remco horters",
      number_suffix: "",
      billing_email: "",
      secondary_emails: []
    },
    billing_method: 1,
    cycle: "weekly",
    legal_name: "",
    coc: "",
    vat_number: "",
    iban: "",
    eori_number: "",
    vat_tariff: 210,
    vat_type: "general",
    vat_number_uk: "",
    reference: "",
    voec_number: ""
  },
  account_id: 33,
  shop_id: 96,
  username: "remco+testing@myparcel.nl",
  shop_name: "eersteshop",
  platform_id: 1,
  number: "P240000050",
  invoice_date: "2024-12-18",
  transaction_date: "2024-12-18",
  start: "2024-12-18",
  end: "2024-12-18",
  created: "2024-12-18 16:14:48",
  modified: "2024-12-18 16:15:02",
  paid: 1
}, da = (e = {}) => ({
  ...Ge,
  ...e
}), Ke = {
  name: "PayPal",
  description: "Online payment system",
  image: "paypal.png",
  cc: ["NL", "BE"]
}, V = (e = {}) => ({
  ...Ke,
  ...e
}), oa = (e = []) => e.length ? e.map((i) => V(i)) : [
  V({
    name: "PayPal",
    description: "Online payment system",
    image: "paypal-logo.png"
  }),
  V({
    name: "iDEAL",
    description: "Dutch payment method",
    image: "ideal-logo.png",
    cc: ["NL"]
  }),
  V({
    name: "Bancontact",
    description: "Belgian payment method",
    image: "bancontact-logo.png",
    cc: ["BE"]
  })
], Ze = {
  id: 1,
  account_id: 123,
  shop_id: 456,
  cc: "NL",
  package_type: 1,
  price: {
    amount: 500,
    currency: "EUR"
  },
  enabled: !0,
  position_order: 1
}, z = (e = {}) => ({
  ...Ze,
  ...e
}), _a = (e = []) => e.length ? e.map(
  (i, d) => z({
    position_order: d + 1,
    id: d + 1,
    ...i
  })
) : [
  z({
    cc: "NL",
    price: {
      amount: 250,
      currency: "EUR"
    }
  }),
  z({
    id: 2,
    cc: "BE",
    price: {
      amount: 350,
      currency: "EUR"
    },
    position_order: 2
  }),
  z({
    id: 3,
    cc: "DE",
    price: {
      amount: 400,
      currency: "EUR"
    },
    position_order: 3
  })
], Je = {
  active: !0,
  id: 1,
  bracket_range_id: 1,
  price: 1,
  product_id: 1,
  weight_tier: null
}, sa = (e) => ({
  ...Je,
  ...e
}), ma = () => [
  {
    name: "damaged",
    human: "Artikel(en) is/zijn beschadigd"
  },
  {
    name: "changed_my_mind",
    human: "Ik heb me bedacht"
  },
  {
    name: "color_not_as_expected",
    human: "De kleur is anders dan ik had verwacht"
  },
  {
    name: "delivered_too_late",
    human: "Ik heb het artikel niet op tijd ontvangen"
  },
  {
    name: "dont_need_it_anymore",
    human: "Ik heb het artikel niet meer nodig"
  },
  {
    name: "ordered_multiple_products",
    human: "Ik heb meerdere artikelen besteld, de juiste houd ik"
  },
  {
    name: "ordered_wrong_product",
    human: "Ik heb het verkeerde product besteld"
  },
  {
    name: "product_not_as_expected",
    human: "Het artikel komt niet overeen met afbeelding/productinformatie"
  },
  {
    name: "quality_not_as_expected",
    human: "Ik had een hogere kwaliteit verwacht"
  },
  {
    name: "received_wrong_product",
    human: "Verkeerde artikel(en) ontvangen"
  },
  {
    name: "received_wrong_size",
    human: "Ik heb de verkeerde maat/afmeting ontvangen"
  },
  {
    name: "other",
    human: "Andere reden"
  },
  {
    name: "product_cheaper_elsewhere",
    human: "Het artikel is elders goedkoper"
  },
  {
    name: "product_incomplete",
    human: "Het artikel is incompleet"
  },
  {
    name: "product_not_functional",
    human: "Het artikel werkt niet"
  },
  {
    name: "product_spoiled",
    human: "Het artikel is bedorven"
  },
  {
    name: "product_too_large",
    human: "Het artikel is te groot"
  },
  {
    name: "product_too_small",
    human: "Het artikel is te klein"
  }
], qe = {
  uri: "https://www.myhermes.de/empfangen/sendungsverfolgung/?suche=H1029870281944901072",
  barcode: "H1029870281944901072"
}, pa = (e = {}) => ({
  ...qe,
  ...e
}), Qe = {
  cc: "NL",
  postal_code: "2131AD",
  street: "Noordmeerstraat",
  city: "HOOFDDORP",
  number: "22",
  location_name: "Pakketautomaat",
  location_code: "405436",
  retail_network_id: "PNPNL-01"
}, ga = (e = {}) => ({
  ...Qe,
  ...e
}), Xe = {
  delivery_type: xe.Standard,
  insurance: {
    amount: 0,
    currency: "EUR"
  },
  label_description: "",
  package_type: ce.Package
}, er = (e = {}) => ({
  ...Xe,
  ...e
}), rr = {
  account_id: 15,
  barcode: "",
  carrier_id: T.PostNl,
  collection_contact: null,
  contract_id: 1,
  created: "2025-02-17 08:47:08",
  created_by: 20,
  customs_declaration: null,
  delayed: !1,
  delivered: !1,
  drop_off_point: null,
  external_identifier: null,
  external_provider: null,
  external_provider_id: null,
  hidden: 0,
  id: 15053611,
  link_consumer_portal: null,
  modified: "2025-02-17 08:47:08",
  modified_by: 20,
  multi_collo_main_shipment_id: null,
  options: er({
    label_description: "test label description",
    large_format: 1,
    only_recipient: 0,
    return: 0,
    signature: 0
  }),
  parent_id: null,
  partner_tracktraces: [],
  payment_status: "unpaid",
  physical_properties: null,
  pickup: null,
  pickup_request_number: null,
  platform_id: 1,
  price: {
    amount: 1168,
    currency: "EUR"
  },
  recipient: ue(),
  reference_identifier: null,
  region: "NL",
  secondary_shipments: [],
  sender: ue({
    company: "MyParcel",
    email: "admin@myparcel.nl",
    person: "MyParcel Admin",
    phone: "023 303 0315"
  }),
  shipment_type: 1,
  shop_id: 17,
  status: 1,
  transaction_status: "unpaid"
}, fa = (e = {}) => ({
  ...rr,
  ...e
}), ar = {
  id: 1,
  account_id: 16,
  shop_id: 18,
  platform_id: 1,
  invoice_id: 1,
  product_id: 501,
  shipment_id: 1,
  barcode: "3SMYPA123456789",
  invoice_number: "250000001",
  name: "Extra with VAT",
  description: "Hierbij je geld terug.",
  account_name: "myparcel",
  shop_name: "myparcel.nl",
  credit: !0,
  no_vat: !1,
  price: {
    amount: 12300,
    currency: "EUR"
  },
  created: "2024-10-28 15:40:53",
  modified: "2024-10-28 15:40:53"
}, ya = (e = {}) => ({
  ...ar,
  ...e
}), nr = {
  id: 1,
  content: "<p>Globale melding.</p>",
  active: !1,
  additional_filter: "NL",
  message_type: 1,
  created: "2022-11-28 13:09:19",
  modified: "2022-11-29 10:13:14",
  start_date: "2022-11-29 10:13:14",
  notification_type: "info",
  content_nl: "In sommige gevallen worden berichten niet gelezen",
  content_en: "In some cases messages are not read",
  content_fr: "Dans certains cas, les messages ne sont pas lus",
  platform_ids: [1],
  platform_id: 1,
  system_message_id: 1,
  end_date: "2022-12-29 10:13:14"
}, ba = (e = {}) => ({
  ...nr,
  ...e
}), tr = {
  shipment_id: 15016384,
  carrier: 1,
  code: "I01",
  description: "Zending is bezorgd",
  time: "2024-03-20 14:59:50",
  link_consumer_portal: `https://${U}.myparcel.me/track-trace/3SMYPO337045004/2132WT/NL`,
  link_tracktrace: "https://postnl.nl/tracktrace/?B=3SMYPO337045004&P=2151DP&D=NL&T=C&L=NL",
  partner_tracktraces: [],
  recipient: {
    cc: "NL",
    postal_code: "2132WT",
    city: "Hoofddorp",
    street: "Siriusdreef",
    street_additional_info: "",
    number: "66",
    number_suffix: "",
    person: "Pietje Puk",
    email: "unit@myparcel.nl",
    secondary_emails: null,
    phone: "0612345678",
    eori_number: "",
    vat_number: ""
  },
  sender: {
    email: "unit@myparcel.nl",
    phone: "0634207712",
    company: "Myparcel",
    postal_code: "2132WT",
    number: "66",
    street: "Siriusdreef",
    street_additional_info: "",
    city: "Hoofddorp",
    cc: "NL",
    person: "Pietje Puk",
    number_suffix: "",
    secondary_emails: []
  },
  options: {
    package_type: 1,
    collect: 0,
    only_recipient: 0,
    signature: 0,
    return: 0,
    insurance: {
      amount: 0,
      currency: "EUR"
    },
    large_format: 0,
    age_check: 0,
    saturday_delivery: 0,
    drop_off_at_postal_point: 0,
    label_description: "",
    delivery_type: 2
  },
  pickup: null,
  delayed: !1,
  location: null,
  status: {
    current: 7,
    main: "delivered",
    final: !0
  },
  history: [
    {
      code: "I01",
      status: 7,
      main: null,
      description: "Shipment delivered",
      time: "2024-06-11 12:20:30",
      delayed: !1,
      location: null
    },
    {
      code: "J05",
      status: 5,
      main: "distribution",
      description: "Deliverer en route",
      time: "2024-06-11 08:05:09",
      delayed: !1,
      location: {
        name: "DEPOT NAME HERE",
        cc: null,
        city: null,
        postal_code: null,
        street: null,
        number: null,
        number_suffix: null,
        longitude: null,
        latitude: null
      }
    },
    {
      code: "J01",
      status: 4,
      main: "sorting",
      description: "Shipment sorted at sorting centre",
      time: "2024-06-11 06:43:59",
      delayed: !1,
      location: {
        name: "SORTEERCENTRUM",
        cc: null,
        city: null,
        postal_code: null,
        street: null,
        number: null,
        number_suffix: null,
        longitude: null,
        latitude: null
      }
    },
    {
      code: "B01",
      status: 3,
      main: "handed_to_carrier",
      description: "Shipment at PostNL",
      time: "2024-06-10 16:31:40",
      delayed: !1,
      location: {
        name: "CARRIER LOCATION NAME HERE",
        cc: null,
        city: null,
        postal_code: null,
        street: null,
        number: null,
        number_suffix: null,
        longitude: null,
        latitude: null
      }
    },
    {
      code: "A01",
      status: 2,
      main: "registered",
      description: "The shipment has been registered and will be trackable",
      time: "2024-06-10 13:56:19",
      delayed: !1,
      location: null
    }
  ],
  delivery_moment_type: "estimated",
  delivery_moment: {
    start: {
      date: "2024-06-05 14:00:00.000000",
      timezone_type: 3,
      timezone: "Europe/Amsterdam"
    },
    end: {
      date: "2024-06-05 16:30:00.000000",
      timezone_type: 3,
      timezone: "Europe/Amsterdam"
    }
  },
  returnable: !1
}, ir = {
  shipment_id: 15016384,
  carrier: 1,
  code: "S02",
  description: "Zending is bezorgd",
  time: "2024-03-20 14:59:50",
  link_consumer_portal: `https://${U}.myparcel.me/track-trace/3SMYPA000000000/2151DP/NL`,
  link_tracktrace: "https://postnl.nl/tracktrace/?B=3SMYPO337045004&P=2151DP&D=NL&T=C&L=NL",
  partner_tracktraces: [],
  recipient: {
    cc: "NL",
    postal_code: "2132JE",
    city: "Hoofddorp",
    street: "Antareslaan",
    street_additional_info: "",
    number: "31",
    number_suffix: "",
    person: "MyParcel",
    email: "info@myparcel.nl",
    secondary_emails: null,
    phone: "0612345678",
    eori_number: "",
    vat_number: ""
  },
  sender: {
    email: "info@myparcel.nl",
    phone: "0612345678",
    company: "Myparcel",
    postal_code: "2132JE",
    number: "31",
    street: "Antareslaan",
    street_additional_info: "",
    city: "Hoofddorp",
    cc: "NL",
    person: "MyParcel",
    number_suffix: "",
    secondary_emails: []
  },
  options: {
    package_type: 1,
    collect: 0,
    only_recipient: 0,
    signature: 0,
    return: 0,
    insurance: {
      amount: 0,
      currency: "EUR"
    },
    large_format: 0,
    age_check: 0,
    saturday_delivery: 0,
    drop_off_at_postal_point: 0,
    label_description: "",
    delivery_type: 2
  },
  pickup: null,
  delayed: !1,
  location: null,
  status: {
    current: 7,
    main: "delivered",
    final: !0
  },
  history: [
    {
      code: "I01",
      status: 7,
      main: null,
      description: "Shipment delivered",
      time: "2024-06-11 12:20:30",
      delayed: !1,
      location: null
    },
    {
      code: "J05",
      status: 5,
      main: "distribution",
      description: "Deliverer en route",
      time: "2024-06-11 08:05:09",
      delayed: !1,
      location: {
        name: "DEPOT NAME HERE",
        cc: null,
        city: null,
        postal_code: null,
        street: null,
        number: null,
        number_suffix: null,
        longitude: null,
        latitude: null
      }
    },
    {
      code: "J01",
      status: 4,
      main: "sorting",
      description: "Shipment sorted at sorting centre",
      time: "2024-06-11 06:43:59",
      delayed: !1,
      location: {
        name: "SORTEERCENTRUM",
        cc: null,
        city: null,
        postal_code: null,
        street: null,
        number: null,
        number_suffix: null,
        longitude: null,
        latitude: null
      }
    },
    {
      code: "B01",
      status: 3,
      main: "handed_to_carrier",
      description: "Shipment at PostNL",
      time: "2024-06-10 16:31:40",
      delayed: !1,
      location: {
        name: "CARRIER LOCATION NAME HERE",
        cc: null,
        city: null,
        postal_code: null,
        street: null,
        number: null,
        number_suffix: null,
        longitude: null,
        latitude: null
      }
    },
    {
      code: "A01",
      status: 2,
      main: "registered",
      description: "The shipment has been registered and will be trackable",
      time: "2024-06-10 13:56:19",
      delayed: !1,
      location: null
    }
  ],
  delivery_moment_type: "estimated",
  delivery_moment: {
    start: {
      date: "2024-06-05 14:00:00.000000",
      timezone_type: 3,
      timezone: "Europe/Amsterdam"
    },
    end: {
      date: "2024-06-05 16:30:00.000000",
      timezone_type: 3,
      timezone: "Europe/Amsterdam"
    }
  },
  returnable: !1
}, ka = (e = {}) => ({
  ...tr,
  ...e
}), va = (e = {}) => ({
  ...ir,
  ...e
}), lr = {
  id: 1,
  account_id: 692,
  name: "http://harmful-fund.biz1697713399325",
  billing: {
    address: {
      email: "unit@myparcel.nl",
      phone: "0612345678",
      company: "Myparcel",
      postal_code: "2132WT",
      number: "66",
      street: "Siriusdreef",
      street_additional_info: "",
      city: "Hoofddorp",
      cc: "NL",
      person: "Pietje Puk"
    },
    billing_method: 2,
    cc_main_email_in_billing_emails: 1,
    cycle: "weekly",
    legal_name: "Myparcel B.V.",
    coc: "12345678",
    vat_number: "",
    iban: "",
    eori_number: "",
    vat_tariff: 210,
    vat_type: "general"
  },
  hidden: !1,
  modified: "2023-10-19 13:03:25",
  platform_id: 1,
  created: "2023-10-19 13:03:25",
  general_settings: {
    auto_save_addresses: 1,
    reminder_email: 0,
    use_logo_label: 0,
    label_format: "A4",
    weight: 1e3,
    label_format_locked: 0,
    label_description: "",
    fulfilment_mode: "manual"
  },
  branding: void 0,
  return: {
    use_shop_shipment_options: 0,
    use_printerless_return: 0,
    settle_printerless_return_cost: 0,
    address: {
      email: "unit@myparcel.nl",
      phone: "0612345678",
      company: "Myparcel",
      postal_code: "2132WT",
      number: "66",
      street: "Siriusdreef",
      street_additional_info: "",
      city: "Hoofddorp",
      cc: "NL",
      person: "Pietje Puk"
    }
  },
  delivery_address: {
    gender: "mr",
    first_name: "Pietje",
    last_name: "Puk",
    email: "unit@myparcel.nl",
    phone: "0612345678",
    company: "Myparcel",
    postal_code: "2132WT",
    number: "66",
    street: "Siriusdreef",
    street_additional_info: "",
    city: "Hoofddorp",
    cc: "NL"
  },
  return_reason_settings: null,
  tracktrace: {
    bcc: 0,
    bcc_email: "",
    carrier_email_basic_notification: 1,
    delivery_notification: 0,
    email_on_handed_to_carrier: 1,
    from_address_company: "Myparcel",
    from_address_email: "unit@myparcel.nl",
    send_track_trace_emails: 0
  }
}, ha = (e = {}) => ({
  ...lr,
  ...e
}), de = (e, i) => {
  const d = e.__vccOpts || e;
  for (const [p, E] of i)
    d[p] = E;
  return d;
}, ur = {}, cr = { role: "dialog" };
function dr(e, i) {
  return B(), K("div", cr, [
    A(e.$slots, "default")
  ]);
}
const Pa = /* @__PURE__ */ de(ur, [["render", dr]]), or = {};
function _r(e, i) {
  return B(), K("div", null, [
    A(e.$slots, "header"),
    fe("div", null, [
      A(e.$slots, "default")
    ])
  ]);
}
const Sa = /* @__PURE__ */ de(or, [["render", _r]]), sr = { "data-test": "slot-stub" }, Ea = /* @__PURE__ */ Z({
  __name: "SlotStub",
  setup(e) {
    return (i, d) => (B(), K("div", sr, [
      A(i.$slots, "default")
    ]));
  }
}), mr = { "data-test": "loaded-stub" }, wa = /* @__PURE__ */ Z({
  __name: "LoadedStub",
  emits: ["loaded"],
  setup(e, { emit: i }) {
    const d = i;
    return ye(() => {
      d("loaded");
    }), (p, E) => (B(), K("div", mr, [
      A(p.$slots, "default")
    ]));
  }
}), La = /* @__PURE__ */ Z({
  __name: "RouterLinkStub",
  props: {
    to: {},
    tag: { default: "a" },
    exact: { type: Boolean },
    exactPath: { type: Boolean },
    append: { type: Boolean },
    replace: { type: Boolean },
    activeClass: { default: "" },
    exactActiveClass: { default: "" },
    exactPathActiveClass: { default: "" },
    event: { default: "click" }
  },
  setup(e) {
    return (i, d) => (B(), be(ke(i.tag), {
      href: i.tag === "a" && typeof i.to == "string" ? i.to : void 0,
      "data-test": "router-link-stub"
    }, {
      default: ve(() => [
        A(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["href"]));
  }
}), pr = typeof setImmediate == "function" ? setImmediate : setTimeout, Ma = () => new Promise((e) => {
  pr(e);
}), gr = (e) => e.charAt(0).toUpperCase() + e.slice(1), xa = (e) => Z({
  name: "SuspenseWrapper",
  props: e.props,
  emits: e.emits,
  render() {
    const i = {
      ...this.$props
    };
    e.emits?.forEach((p) => {
      i[`on${gr(p)}`] = (...E) => this.$emit(p, ...E);
    });
    const d = this.$slots;
    return W(
      "div",
      { id: "root" },
      W(he, null, {
        default() {
          return W(e, i, d);
        },
        fallback: () => W("div", "fallback")
      })
    );
  }
});
function Na(e) {
  return e.replace(/aria-controls="[^"]+"/g, 'aria-controls="dynamic-id"').replace(/id="[^"]+"/g, 'id="dynamic-id"').replace(/aria-labelledby="[^"]+"/g, 'aria-labelledby="dynamic-id"');
}
const re = (e) => e.ownerDocument === e.getRootNode({ composed: !0 }) ? oe(e) : !1, oe = (e) => !(!fr(e) || !yr(e) || e.parentElement && !oe(e.parentElement) || e.offsetParent === null), fr = (e) => {
  const { getComputedStyle: i } = e.ownerDocument.defaultView, d = i(e);
  return d.display !== "none" && d.visibility !== "hidden" && d.visibility !== "collapse" && d.opacity !== "0" && d.opacity !== 0;
}, yr = (e) => {
  const i = e.nodeName === "DETAILS" ? e.hasAttribute("open") : !0;
  return !e.hasAttribute("hidden") && i;
}, Da = () => {
  const e = Pe([]);
  return {
    openItems: e,
    border: !1,
    setOpenItem: (d) => {
      e.value = [...e.value, d];
    }
  };
};
function $a(e, i = {}) {
  const { within: d } = require("@testing-library/vue"), { affectsPrice: p = !1, depth: E = 2, customMessage: h } = i, m = e.attributes.getNamedItem("name")?.value || "element", y = h || (p ? "Optioneel en beïnvloedt de prijs" : "Optioneel");
  let k = e;
  for (let P = 0; P < E; P++)
    k = k?.parentElement;
  const b = d(k).queryByText(y, { exact: !0 }), x = b !== null && re(b);
  return {
    pass: x,
    message: () => x ? this.isNot ? `Expected ${m} NOT to have a visible sublabel containing "${y}", but it was found.` : `${m} correctly has a visible sublabel containing "${y}".` : this.isNot ? `${m} correctly does NOT have a visible sublabel containing "${y}".` : `Expected ${m} to have a visible sublabel containing "${y}", but it was not found.`
  };
}
function Ta(e, i, d = {}) {
  const { within: p } = require("@testing-library/vue"), { depth: E = 3 } = d;
  let h = e;
  for (let b = 0; b < E; b++)
    h = h?.parentElement;
  const m = p(h).queryByRole("tooltip"), y = m?.textContent?.includes(i), k = m !== null && re(m) && !!y;
  return {
    pass: k,
    message: () => k ? this.isNot ? `Expected tooltip NOT to have a visible tooltip containing ${i}, but it was found.` : `tooltip correctly has a visible tooltip containing "${i}".` : this.isNot ? `tooltip correctly does NOT have a visible tooltip containing "${i}".` : `Expected tooltip to have a visible tooltip containing "${i}", but it was not found.`
  };
}
function Ra(e, i, d = {}) {
  const { within: p } = require("@testing-library/vue"), { depth: E = 3 } = d, h = e.attributes.getNamedItem("name")?.value || "element";
  let m = e;
  for (let b = 0; b < E; b++)
    m = m?.parentElement;
  const y = p(m).queryByText(i, { exact: !0 }), k = y !== null && re(y);
  return {
    pass: k,
    message: () => k ? this.isNot ? `Expected ${h} NOT to have a visible error containing "${i}", but it was found.` : `${h} correctly has a visible error containing "${i}".` : this.isNot ? `${h} correctly does NOT have a visible error containing "${i}".` : `Expected ${h} to have a visible error containing "${i}", but it was not found.`
  };
}
const _e = {}, Ha = (e, i) => {
  _e[e] = i;
}, Aa = () => ({
  install: (e) => {
    e.config.globalProperties.$isFeatureActive = (i) => _e[i] ?? !1;
  }
});
export {
  Xr as DHLForYouCarrierConfiguration,
  Yr as DHLParcelBeXL,
  jr as DHLParcelBeXXL,
  Fr as DHLParcelNlL,
  Ur as DHLParcelNlM,
  Br as DHLParcelNlS,
  Er as Dm3Refund0_55,
  Lr as Dm3Refund105_205,
  wr as Dm3Refund55_105,
  Pr as EveningDelivery,
  wa as LoadedStub,
  Sa as MainStub,
  Pa as ModalStub,
  Sr as MorningDelivery,
  Qr as PostNLCarrierConfiguration,
  $r as PostNl500ToBe,
  Mr as PostNlFrom500,
  xr as PostNlTo100,
  Nr as PostNlTo250,
  Dr as PostNlTo500,
  La as RouterLinkStub,
  Ir as ShipmenEs,
  Cr as ShipmentDe,
  U as ShopBrandingSubdomain,
  Ea as SlotStub,
  zr as WeightAU,
  Wr as WeightRow,
  Vr as WeightUS,
  Da as accordionProvider,
  Tr as bundleMaxLabelDiscount,
  Hr as bundlePlusLabelDiscount,
  Ar as bundlePremiumLabelDiscount,
  Rr as bundleStartLabelDiscount,
  ue as createAddress,
  Jr as createBracket,
  ea as createCarrierOption,
  Kr as createCarrierReference,
  ra as createCollectTrip,
  na as createCollectTripDisabledDay,
  aa as createCollectTripSchedule,
  ta as createConsumerPortalFields,
  va as createDemoTrackAndTrace,
  kr as createExternalProvider,
  vr as createExternalProviderExpired,
  hr as createExternalProviderExpiringSoon,
  da as createInvoice,
  Gr as createMyParcelAccount,
  pa as createPartnerBarcode,
  V as createPaymentGateway,
  oa as createPaymentGatewayList,
  ia as createPaymentStatus,
  sa as createPrice,
  ga as createRetailLocation,
  z as createReturnContribution,
  _a as createReturnContributionList,
  la as createReturnReasonSettings,
  ma as createReturnReasonsMock,
  ua as createReturnShipment,
  fa as createShipment,
  er as createShipmentOptions,
  qr as createShopBranding,
  ha as createShopMock,
  ca as createSocialShippingLinksMock,
  ya as createSpecialInvoiceItem,
  ba as createSystemMessage,
  ka as createTrackAndTrace,
  He as defaultCarrierReference,
  nr as defaultSystemMessage,
  Ma as flushPromises,
  re as isVisible,
  Na as removeDynamicId,
  $e as roles,
  Zr as sendMyParcelAccount,
  Ha as setFeature,
  Or as shipmentEU1And2,
  xa as suspenseWrapper,
  Aa as testFeatures,
  Ra as toHaveFormError,
  $a as toHaveOptionalSublabel,
  Ta as toHaveTooltip,
  Te as user
};
